import { createBrowserRouter, Navigate } from 'react-router';
import { Layout } from 'components/layout';
import { V2QSScreen } from 'screens/v2qs';
import { CameraScreen } from 'screens/camera';
import { ErrorBoundary } from 'components/error-boundary';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Navigate to="/v2qs" replace />,
      },
      {
        path: 'v2qs',
        element: <V2QSScreen />,
      },
      {
        path: 'camera',
        element: <CameraScreen />,
      },
    ],
  },
]);
